import ActionTypes from '../actionTypes/actionTypes';
import { VIEW, DATE_FORMAT } from '../../constants/appConstants';
import { DATE_FILTER } from '../../components/views/FilterView/constants';

import moment from 'moment';

const DEFAULT_FILTER = {
    [VIEW.WINDOW_LIST_VIEW]: { 
        dateFilter: { 
            type: DATE_FILTER.BY_TODAY 
        }, 
        gangIds: []
    },
    [VIEW.MY_WINDOW_VIEW]: {
        dateFilter: { 
            type: DATE_FILTER.BY_RANGE,
            value: {
                startDate: moment().format(DATE_FORMAT),
                endDate: moment().add(1, 'y').format(DATE_FORMAT)
            }
        }, 
        gangIds: []
    }
};

let lsFilter = localStorage.getItem('filter');
    
if (lsFilter) {
    lsFilter = JSON.parse(lsFilter);
}

export default (state = lsFilter || DEFAULT_FILTER, action) => {
    let newFilter;

    switch (action.type) {
        case ActionTypes.SET_FILTER_ALL_WINDOW :
            newFilter = Object.assign({}, state, {
                [VIEW.WINDOW_LIST_VIEW]: action.filter
            });
            break;
        case ActionTypes.SET_FILTER_MY_WINDOW: 
            newFilter = Object.assign({}, state, {
                [VIEW.MY_WINDOW_VIEW]: action.filter
            });
            break;
        default:
            newFilter = Object.assign({}, state);
            break;
    }

    localStorage.setItem('filter', JSON.stringify(newFilter));

    return newFilter;
}